/* eslint-disable max-len */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import BaseSvgIcon from "./Base";
var Delete = function (props) { return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 16 17" }),
    React.createElement("g", { id: "UX-Specification-document", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("g", { id: "Insights-homepage,-Archived-surveys-tab---Desktop", transform: "translate(-1106.000000, -289.000000)", stroke: "#3D3D35", strokeWidth: "1.3" },
            React.createElement("g", { id: "Delete-Survey", transform: "translate(1106.000000, 290.000000)" },
                React.createElement("path", { d: "M2.12,2.43 L2.12,13 C2.12,14.1653208 3.06467918,15.11 4.23,15.11 L10.73,15.11 C11.8930462,15.1045268 12.8345268,14.1630462 12.84,13 L12.84,2.67", id: "Path" }),
                React.createElement("path", { d: "M0.72,2.43 L14.49,2.43", id: "Path" }),
                React.createElement("path", { d: "M6.24,0.07 L8.89,0.07 C9.7626099,0.07 10.47,0.777390095 10.47,1.65 L10.47,2.42 L4.66,2.42 L4.66,1.65 C4.66,0.777390095 5.3673901,0.07 6.24,0.07 Z", id: "Path" }),
                React.createElement("path", { d: "M4.81,5.37 L4.81,12.11", id: "Path" }),
                React.createElement("path", { d: "M10.48,5.37 L10.48,12.11", id: "Path" }),
                React.createElement("path", { d: "M7.6,4.46 L7.6,12.76", id: "Path" })))))); };
export default Delete;
